<template>
  <div class="modal">
    <TitleArea
      text="クイズミッション"
      @click-close="onClickClose"
      :showReturn="true"
    />
    <div class="modal-content-area">
      <ul class="questions">
        <li v-for="(item, index) in selectedMission.quiz_items" :key="index">
          <QuizItem
            :quizItem="item"
            :selectedMission="selectedMission"
            :index="index"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import TitleArea from "@/components/Atoms/TitleArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import QuizItem from "./QuizItem";

export default {
  name: "show-mission-area",
  components: {
    TitleArea,
    ButtonTextLink,
    QuizItem,
  },
  props: {
    distance: { type: Number, require: true },
    selectedMission: { type: Object, require: true },
  },
  computed: {
    displayDistance() {
      const n = 1;
      return Math.round(this.distance * Math.pow(10, n)) / Math.pow(10, n);
    },
  },
  methods: {
    onClickClose() {
      this.$emit("click-close");
    },
    onCickTry() {
      this.$emit("click-try");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.modal {
  background-color: white;
  z-index: 3;
  transform: translateZ(3px);
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  .modal-content-area {
    padding: 2.5rem 0 3rem 0;
    height: calc(100% - 8rem);
    overflow: scroll;
  }
}

.questions {
  padding: 0;
  margin: 0;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/QuizMission/QuizListModal.vue